export class UserDTO {
  private email: string;
  private password: string;
  private otp: string;
  private role: string
  private termsAndConditions: boolean;
  private gdpr: boolean;
  private roeid: boolean;

  constructor(email: string = null, password: string = null, otp: string = null, role: string = null, termsAndConditions: boolean = null, gdpr: boolean = null,
              roeid: boolean = null) {
    this.email = email;
    this.password = password;
    this.otp = otp;
    this.role = role;
    this.termsAndConditions = termsAndConditions;
    this.gdpr = gdpr;
    this.roeid = roeid;
  }
}
